import { useScales } from '@Contexts/scales';
import type { ApiWeighing, ApiWeighingSlip } from '@Model';
import { useCallback } from 'react';

export enum EnumWeighing {
    Gross,
    Tare,
}

export function useWeighing() {
    const { getWeight, selectedScale } = useScales();

    const setWeight = useCallback(
        (weighing_slip: ApiWeighingSlip, phase: EnumWeighing, weight: ApiWeighing | number) => {
            if (typeof weight === 'number') {
                if (selectedScale !== undefined) {
                    weighing_slip.unit = selectedScale.unit;
                }

                if (phase === EnumWeighing.Gross) {
                    weighing_slip.gross_weight = weight;
                    weighing_slip.gross_weighing_date = undefined;
                    weighing_slip.gross_weighing_counter = '';
                    weighing_slip.gross_scale_number = '';
                } else {
                    weighing_slip.tare_weight = weight;
                    weighing_slip.tare_weighing_date = undefined;
                    weighing_slip.tare_weighing_counter = '';
                    weighing_slip.tare_scale_number = '';
                }
            } else {
                weighing_slip.unit = weight.unit;

                if (phase === EnumWeighing.Gross) {
                    weighing_slip.gross_weight = weight.weight;
                    weighing_slip.gross_weighing_date = weight.created_at;
                    weighing_slip.gross_weighing_counter = weight.serial_number;
                    weighing_slip.gross_scale_number = weight.scale_number;
                } else {
                    weighing_slip.tare_weight = weight.weight;
                    weighing_slip.tare_weighing_date = weight.created_at;
                    weighing_slip.tare_weighing_counter = weight.serial_number;
                    weighing_slip.tare_scale_number = weight.scale_number;
                }
            }
        },
        [selectedScale],
    );

    return {
        setWeight,
        getWeight,
    };
}
